// extracted by mini-css-extract-plugin
export default {"page":"iH","freeShippingContainer":"jH","customizeContainer":"kH","customizeHeader":"lH","fadein":"mH","customizeText":"nH","hidden":"oH","productcard":"pH","accordeonscontainer":"qH","freeShipping":"rH","mainpart":"sH"};
    if(module.hot) {
      // 1715188236505
      var cssReload = require("../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  